import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number1Circle"
const Number1CircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M13.725 6.75V17.25H11.7V9.09L9.75 10.17V8.25L12.3 6.75z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default Number1CircleIcon
